module.exports = __webpack_public_path__ + "static/media/txt_prn9.dca905eb.png";